import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { nextQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const OXPopupHider = ( props ) => {

  const dispatch = useDispatch();
  const nextQuestion = payload => { dispatch( nextQuestionAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( nextQuestion, 1000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  return props.children || null;

};

export default OXPopupHider;
